import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

const TimelineNachhaltigkeit = ({  }) => {
    const [activeTab, setActiveTab] = useState(1);
    const tabs = [
        {
            id: 1,
            title: "Langfristig",
            icon: "/images/Langfristig-icon.svg",
        },
        {
            id: 2,
            title: "Verantwortungsvoll",
            icon: "/images/Verantwortungsvoll-icon.svg",
        },
        {
            id: 3,
            title: "Gemeinnützig",
            icon: "/images/Gemeinnutzig-icon.svg",
        },
        {
            id: 4,
            title: "Zukunftsorientiert",
            icon: "/images/Zukunftsorientiert-icon.svg",
        },
    ];

    const steps = [
    {
        image: "/images/langfristig-icon-1.svg",
        title: "Idee",
        text: "Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis.",
    },
    {
        image: "/images/langfristig-icon-2.svg",
        title: "Planung",
        text: "Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis.",
    },
    {
        image: "/images/langfristig-icon-3.svg",
        title: "Bau",
        text: "Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis.",
    },
    {
        image: "/images/langfristig-icon-4.svg",
        title: "Bewirtschaftung",
        text: "Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis.",
    },
    {
        image: "/images/langfristig-icon-5.svg",
        title: "Erhalten",
        text: "Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis.",
    },
    ];

    return (
    <div className='nachhalt_timeline'>
        <div className="tab-list">
            <div className='row'>
            {tabs.map((tab) => (
                <div className='col-6 col-md-3 tab-card mb-4'>
                    <button key={tab.id} className={`text-center ${ activeTab === tab.id ? "active" : "" }`} onClick={() => setActiveTab(tab.id)} >
                        <img src={tab.icon} alt={tab.title} />
                        <h4 className='fs_24 fw-500 mb-0'>{tab.title}</h4>
                    </button>
                </div>
            ))}
            </div>
        </div>
        <div className="tab-content">
            {activeTab === 1 && (
            <div className="tab-pane-content">
                <div class="subtitle">Proin gravida</div>
                <h2 class="text-black mb-2">Ganzheitlich denken. Langfristig handeln.</h2>
                <div className="timeline row">
                    {steps.map((step, index) => (
                    <div className="timeline_column mb-4 mb-lg-5" key={index}>
                        <div className="timeline-icon">
                            <img src={step.image} alt={step.title} />
                        </div>
                        <div className='mobile_align_pad'>
                            <h4 className="fs_24 fw-500 mt-4">{step.title}</h4>
                            <p>{step.text}</p>
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        )}

        {activeTab === 2 && (
            <div className="tab-pane-content">
                <div class="subtitle">Proin gravida</div>
                <h2 class="text-black mb-2">Verantwortungsvoll</h2>
                <div className="timeline row">
                    {steps.map((step, index) => (
                    <div className="timeline_column mb-4 mb-lg-5" key={index}>
                        <div className="timeline-icon">
                            <img src={step.image} alt={step.title} />
                        </div>
                        <div className='mobile_align_pad'>
                            <h4 className="fs_24 fw-500 mt-4">{step.title}</h4>
                            <p>{step.text}</p>
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        )}

        {activeTab === 3 && (
            <div className="tab-pane-content">
                <div class="subtitle">Proin gravida</div>
                <h2 class="text-black mb-2">Gemeinnützig</h2>
                <div className="timeline row">
                    {steps.map((step, index) => (
                    <div className="timeline_column mb-4 mb-lg-5" key={index}>
                        <div className="timeline-icon">
                            <img src={step.image} alt={step.title} />
                        </div>
                        <div className='mobile_align_pad'>
                            <h4 className="fs_24 fw-500 mt-4">{step.title}</h4>
                            <p>{step.text}</p>
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        )}

        {activeTab === 4 && (
            <div className="tab-pane-content">
                <div class="subtitle">Proin gravida</div>
                <h2 class="text-black mb-2">Zukunftsorientirt</h2>
                <div className="timeline row">
                    {steps.map((step, index) => (
                    <div className="timeline_column mb-4 mb-lg-5" key={index}>
                        <div className="timeline-icon">
                            <img src={step.image} alt={step.title} />
                        </div>
                        <div className='mobile_align_pad'>
                            <h4 className="fs_24 fw-500 mt-4">{step.title}</h4>
                            <p>{step.text}</p>
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        )}
        </div>
    </div>
    )
}

export default TimelineNachhaltigkeit;